// Canonical list of 106 HBCUs — alphabetical order
// Source: U.S. Department of Education designated Historically Black Colleges and Universities
//
// Each entry may include an optional `domain` (the school's primary .edu hostname).
// `getHbcuLogoUrl(name)` uses the domain to fetch the school's logo from a logo CDN.

export const HBCU_LIST = [
  { id: "alabama_am", name: "Alabama A&M University", state: "AL", domain: "aamu.edu" },
  { id: "alabama_state", name: "Alabama State University", state: "AL", domain: "alasu.edu" },
  { id: "albany_state", name: "Albany State University", state: "GA", domain: "asurams.edu" },
  { id: "alcorn_state", name: "Alcorn State University", state: "MS", domain: "alcorn.edu" },
  { id: "allen", name: "Allen University", state: "SC", domain: "allenuniversity.edu" },
  { id: "american_baptist", name: "American Baptist College", state: "TN" },
  { id: "arkansas_baptist", name: "Arkansas Baptist College", state: "AR", domain: "arkansasbaptist.edu" },
  { id: "benedict", name: "Benedict College", state: "SC", domain: "benedict.edu" },
  { id: "bennett", name: "Bennett College", state: "NC", domain: "bennett.edu" },
  { id: "bethune_cookman", name: "Bethune-Cookman University", state: "FL", domain: "cookman.edu" },
  { id: "bishop_state", name: "Bishop State Community College", state: "AL", domain: "bishop.edu" },
  { id: "bluefield_state", name: "Bluefield State University", state: "WV", domain: "bluefieldstate.edu" },
  { id: "bowie_state", name: "Bowie State University", state: "MD", domain: "bowiestate.edu" },
  { id: "central_state", name: "Central State University", state: "OH", domain: "centralstate.edu" },
  { id: "cheyney", name: "Cheyney University of Pennsylvania", state: "PA", domain: "cheyney.edu" },
  { id: "claflin", name: "Claflin University", state: "SC", domain: "claflin.edu" },
  { id: "clark_atlanta", name: "Clark Atlanta University", state: "GA", domain: "cau.edu" },
  { id: "clinton", name: "Clinton College", state: "SC", domain: "clintoncollege.edu" },
  { id: "coahoma", name: "Coahoma Community College", state: "MS", domain: "coahomacc.edu" },
  { id: "concordia_selma", name: "Concordia College Alabama", state: "AL" },
  { id: "coppin_state", name: "Coppin State University", state: "MD", domain: "coppin.edu" },
  { id: "delaware_state", name: "Delaware State University", state: "DE", domain: "desu.edu" },
  { id: "denmark_tech", name: "Denmark Technical College", state: "SC", domain: "denmarktech.edu" },
  { id: "dillard", name: "Dillard University", state: "LA", domain: "dillard.edu" },
  { id: "edward_waters", name: "Edward Waters University", state: "FL", domain: "ewu.edu" },
  { id: "elizabeth_city", name: "Elizabeth City State University", state: "NC", domain: "ecsu.edu" },
  { id: "fayetteville_state", name: "Fayetteville State University", state: "NC", domain: "uncfsu.edu" },
  { id: "fisk", name: "Fisk University", state: "TN", domain: "fisk.edu" },
  { id: "florida_am", name: "Florida A&M University", state: "FL", domain: "famu.edu" },
  { id: "florida_memorial", name: "Florida Memorial University", state: "FL", domain: "fmuniv.edu" },
  { id: "fort_valley", name: "Fort Valley State University", state: "GA", domain: "fvsu.edu" },
  { id: "gadsden_state", name: "Gadsden State Community College", state: "AL", domain: "gadsdenstate.edu" },
  { id: "grambling", name: "Grambling State University", state: "LA", domain: "gram.edu" },
  { id: "trenholm_state", name: "H. Councill Trenholm State Community College", state: "AL", domain: "trenholmstate.edu" },
  { id: "hampton", name: "Hampton University", state: "VA", domain: "hamptonu.edu" },
  { id: "harris_stowe", name: "Harris-Stowe State University", state: "MO", domain: "hssu.edu" },
  { id: "hinds_utica", name: "Hinds Community College (Utica Campus)", state: "MS", domain: "hindscc.edu" },
  { id: "howard", name: "Howard University", state: "DC", domain: "howard.edu" },
  { id: "huston_tillotson", name: "Huston-Tillotson University", state: "TX", domain: "htu.edu" },
  { id: "interdenominational", name: "Interdenominational Theological Center", state: "GA", domain: "itc.edu" },
  { id: "jackson_state", name: "Jackson State University", state: "MS", domain: "jsums.edu" },
  { id: "jarvis_christian", name: "Jarvis Christian University", state: "TX", domain: "jarvis.edu" },
  { id: "johnson_c_smith", name: "Johnson C. Smith University", state: "NC", domain: "jcsu.edu" },
  { id: "kentucky_state", name: "Kentucky State University", state: "KY", domain: "kysu.edu" },
  { id: "knoxville", name: "Knoxville College", state: "TN", domain: "knoxvillecollege.edu" },
  { id: "lane", name: "Lane College", state: "TN", domain: "lanecollege.edu" },
  { id: "langston", name: "Langston University", state: "OK", domain: "langston.edu" },
  { id: "lawson_state", name: "Lawson State Community College", state: "AL", domain: "lawsonstate.edu" },
  { id: "lemoyne_owen", name: "LeMoyne-Owen College", state: "TN", domain: "loc.edu" },
  { id: "lincoln_mo", name: "Lincoln University (Missouri)", state: "MO", domain: "lincolnu.edu" },
  { id: "lincoln_pa", name: "Lincoln University (Pennsylvania)", state: "PA", domain: "lincoln.edu" },
  { id: "livingstone", name: "Livingstone College", state: "NC", domain: "livingstone.edu" },
  { id: "maryland_eastern_shore", name: "University of Maryland Eastern Shore", state: "MD", domain: "umes.edu" },
  { id: "meharry", name: "Meharry Medical College", state: "TN", domain: "mmc.edu" },
  { id: "miles", name: "Miles College", state: "AL", domain: "miles.edu" },
  { id: "mississippi_valley", name: "Mississippi Valley State University", state: "MS", domain: "mvsu.edu" },
  { id: "morehouse", name: "Morehouse College", state: "GA", domain: "morehouse.edu" },
  { id: "morehouse_medicine", name: "Morehouse School of Medicine", state: "GA", domain: "msm.edu" },
  { id: "morgan_state", name: "Morgan State University", state: "MD", domain: "morgan.edu" },
  { id: "morris_brown", name: "Morris Brown College", state: "GA", domain: "morrisbrown.edu" },
  { id: "morris", name: "Morris College", state: "SC", domain: "morris.edu" },
  { id: "norfolk_state", name: "Norfolk State University", state: "VA", domain: "nsu.edu" },
  { id: "north_carolina_at", name: "North Carolina A&T State University", state: "NC", domain: "ncat.edu" },
  { id: "north_carolina_central", name: "North Carolina Central University", state: "NC", domain: "nccu.edu" },
  { id: "oakwood", name: "Oakwood University", state: "AL", domain: "oakwood.edu" },
  { id: "paine", name: "Paine College", state: "GA", domain: "paine.edu" },
  { id: "paul_quinn", name: "Paul Quinn College", state: "TX", domain: "pqc.edu" },
  { id: "philander_smith", name: "Philander Smith University", state: "AR", domain: "philander.edu" },
  { id: "prairie_view", name: "Prairie View A&M University", state: "TX", domain: "pvamu.edu" },
  { id: "rust", name: "Rust College", state: "MS", domain: "rustcollege.edu" },
  { id: "saint_augustines", name: "Saint Augustine's University", state: "NC", domain: "st-aug.edu" },
  { id: "savannah_state", name: "Savannah State University", state: "GA", domain: "savannahstate.edu" },
  { id: "selma", name: "Selma University", state: "AL", domain: "selmauniversity.edu" },
  { id: "shaw", name: "Shaw University", state: "NC", domain: "shawu.edu" },
  { id: "shelton_state", name: "Shelton State Community College", state: "AL", domain: "sheltonstate.edu" },
  { id: "shorter", name: "Shorter College", state: "AR", domain: "shortercollege.edu" },
  { id: "simmons", name: "Simmons College of Kentucky", state: "KY", domain: "simmonscollegeky.edu" },
  { id: "south_carolina_state", name: "South Carolina State University", state: "SC", domain: "scsu.edu" },
  { id: "southern_no", name: "Southern University at New Orleans", state: "LA", domain: "suno.edu" },
  { id: "southern_shreveport", name: "Southern University at Shreveport", state: "LA", domain: "susla.edu" },
  { id: "southern_university", name: "Southern University and A&M College", state: "LA", domain: "subr.edu" },
  { id: "southwestern_christian", name: "Southwestern Christian College", state: "TX", domain: "swcc.edu" },
  { id: "spelman", name: "Spelman College", state: "GA", domain: "spelman.edu" },
  { id: "st_philips", name: "St. Philip's College", state: "TX", domain: "alamo.edu" },
  { id: "stillman", name: "Stillman College", state: "AL", domain: "stillman.edu" },
  { id: "talladega", name: "Talladega College", state: "AL", domain: "talladega.edu" },
  { id: "tennessee_state", name: "Tennessee State University", state: "TN", domain: "tnstate.edu" },
  { id: "texas_college", name: "Texas College", state: "TX", domain: "texascollege.edu" },
  { id: "texas_southern", name: "Texas Southern University", state: "TX", domain: "tsu.edu" },
  { id: "tougaloo", name: "Tougaloo College", state: "MS", domain: "tougaloo.edu" },
  { id: "tuskegee", name: "Tuskegee University", state: "AL", domain: "tuskegee.edu" },
  { id: "arkansas_pine_bluff", name: "University of Arkansas at Pine Bluff", state: "AR", domain: "uapb.edu" },
  { id: "district_columbia", name: "University of the District of Columbia", state: "DC", domain: "udc.edu" },
  { id: "virgin_islands", name: "University of the Virgin Islands", state: "VI", domain: "uvi.edu" },
  { id: "virginia_state", name: "Virginia State University", state: "VA", domain: "vsu.edu" },
  { id: "virginia_union", name: "Virginia Union University", state: "VA", domain: "vuu.edu" },
  { id: "virginia_university_lynchburg", name: "Virginia University of Lynchburg", state: "VA", domain: "vul.edu" },
  { id: "voorhees", name: "Voorhees University", state: "SC", domain: "voorhees.edu" },
  { id: "west_virginia_state", name: "West Virginia State University", state: "WV", domain: "wvstateu.edu" },
  { id: "wilberforce", name: "Wilberforce University", state: "OH", domain: "wilberforce.edu" },
  { id: "wiley", name: "Wiley University", state: "TX", domain: "wileyc.edu" },
  { id: "winston_salem_state", name: "Winston-Salem State University", state: "NC", domain: "wssu.edu" },
  { id: "xavier", name: "Xavier University of Louisiana", state: "LA", domain: "xula.edu" },
];

export const SPELHOUSE_IDS = ['spelman', 'morehouse'];

export const isSpelhouseInstitution = (name) => {
  return name === 'Spelman College' || name === 'Morehouse College';
};

// ── Logo helpers ──

const normalize = (s) => String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();

const HBCU_BY_NORMALIZED_NAME = HBCU_LIST.reduce((acc, h) => {
  acc[normalize(h.name)] = h;
  return acc;
}, {});

// Build a few common alias forms so user-typed school names still match.
const ALIASES = {
  [normalize('Southern University New Orleans')]: 'southern_no',
  [normalize('Southern University of New Orleans')]: 'southern_no',
  [normalize('SUNO')]: 'southern_no',
  [normalize('Southern University Shreveport')]: 'southern_shreveport',
  [normalize('Southern University')]: 'southern_university',
  [normalize('NC A&T')]: 'north_carolina_at',
  [normalize('North Carolina A and T')]: 'north_carolina_at',
  [normalize('FAMU')]: 'florida_am',
  [normalize('Florida A and M')]: 'florida_am',
  [normalize('Alabama A and M')]: 'alabama_am',
  [normalize('Prairie View')]: 'prairie_view',
  [normalize('Hampton U')]: 'hampton',
  [normalize('Tennessee State')]: 'tennessee_state',
  [normalize('Jackson State')]: 'jackson_state',
};

export const findHbcu = (name) => {
  const key = normalize(name);
  if (!key) return null;
  if (HBCU_BY_NORMALIZED_NAME[key]) return HBCU_BY_NORMALIZED_NAME[key];
  const aliasId = ALIASES[key];
  if (aliasId) return HBCU_LIST.find(h => h.id === aliasId) || null;
  // Last-resort: substring match against canonical names.
  const match = HBCU_LIST.find(h => {
    const n = normalize(h.name);
    return n.includes(key) || key.includes(n);
  });
  return match || null;
};

// Returns a logo URL for the given HBCU name, or null if no domain is on file.
// Uses Google's S2 Favicons API — public, free, and stable. Quality is favicon-grade
// (typically 32×32) which is fine at the small sizes we render credentials.
// The <img> tag should onError-fall back to a generic icon.
export const getHbcuLogoUrl = (name) => {
  const h = findHbcu(name);
  if (!h?.domain) return null;
  return `https://www.google.com/s2/favicons?domain=${h.domain}&sz=128`;
};
